export const FM_IMPORT_STATE_LOCAL_STORAGE_KEY = 'family-members-import-state';

export const DEBOUNCE_SAVE_FM_IMPORT_STATE_DELAY_MS = 500;
